import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { interval } from 'rxjs';
import { IconSetService } from '@coreui/icons-angular';
import { StatisticApiService } from './services/rest/statistic-api.service';
import { TokenService } from './services/rest/token.service';
import { iconSubset } from './icons/icon-subset';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: `
      <router-outlet></router-outlet>

      <div class="pending-followup-toasts" *ngIf="!isAuthPage">
        <div *ngIf="showAdminReminder && !adminReminderDismissed" class="pending-followup-toast pending-followup-toast--admin" role="alert">
          <button type="button" class="pending-followup-toast__close" aria-label="Dismiss" (click)="adminReminderDismissed = true">&times;</button>
          <div class="pending-followup-toast__title">Cases not yet cleared</div>
          <div class="pending-followup-toast__message">
            {{ totalPendingFollowUpCases }} case(s) not yet cleared across all users.
          </div>
          <a class="pending-followup-toast__link" [routerLink]="['/dashboard']">Open dashboard</a>
        </div>

        <div *ngIf="showReminder && !reminderDismissed" class="pending-followup-toast"
             [class.pending-followup-toast--urgent]="pendingFollowUpCases.length >= 3"
             [class.pending-followup-toast--closable]="isAdmin" role="alert">
          <button type="button" class="pending-followup-toast__close" aria-label="Dismiss" (click)="reminderDismissed = true">&times;</button>
          <div class="pending-followup-toast__title">Pending follow-up cases</div>
          <div class="pending-followup-toast__message">
            You have {{ pendingFollowUpCases.length }} pending case(s).
          </div>
          <a class="pending-followup-toast__link" [routerLink]="['/dashboard']">Open dashboard</a>
        </div>

        <div class="pending-followup-fabs">
          <button *ngIf="showAdminReminder && adminReminderDismissed" type="button"
                  class="pending-followup-fab pending-followup-fab--admin"
                  aria-label="Show cases not yet cleared"
                  (click)="adminReminderDismissed = false">{{ totalPendingFollowUpCases }}</button>
          <button *ngIf="showReminder && reminderDismissed" type="button"
                  class="pending-followup-fab"
                  aria-label="Show pending follow-up cases"
                  (click)="reminderDismissed = false">{{ pendingFollowUpCases.length }}</button>
        </div>
      </div>
    `,
    styles: [
      `.pending-followup-toasts {
        position: fixed;
        left: 16px;
        bottom: 16px;
        z-index: 2000;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }`,
      `@keyframes pending-followup-glow {
        0%, 100% {
          border-color: rgba(245, 158, 11, 0.35);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18), 0 0 0 0 rgba(245, 158, 11, 0);
        }
        50% {
          border-color: #f59e0b;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18), 0 0 14px 3px rgba(245, 158, 11, 0.75);
        }
      }
      .pending-followup-toast {
        position: relative;
        max-width: 320px;
        padding: 12px 14px;
        border: 1px solid rgba(245, 158, 11, 0.35);
        border-left: 4px solid #f59e0b;
        border-radius: 8px;
        background: #fff8e1;
        color: #7c4a00;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
        animation: pending-followup-glow 2s ease-in-out infinite;
      }
      .pending-followup-toast--admin {
        border-color: rgba(220, 38, 38, 0.35);
        border-left-color: #dc2626;
        background: #fee2e2;
        color: #7f1d1d;
        animation: none;
      }
      @keyframes pending-followup-glow-urgent {
        0%, 100% {
          border-color: rgba(220, 38, 38, 0.35);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18), 0 0 0 0 rgba(220, 38, 38, 0);
        }
        50% {
          border-color: #dc2626;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18), 0 0 14px 3px rgba(220, 38, 38, 0.8);
        }
      }
      .pending-followup-toast--urgent {
        border-left-color: #dc2626;
        animation: pending-followup-glow-urgent 1s ease-in-out infinite;
      }`,
      `.pending-followup-toast__title {
        font-weight: 700;
        margin-bottom: 4px;
      }`,
      `.pending-followup-toast__message {
        font-size: 13px;
        line-height: 1.4;
      }`,
      `.pending-followup-toast__link {
        display: inline-block;
        margin-top: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #0f766e;
        text-decoration: underline;
      }`,
      `.pending-followup-toast__close {
        display: none;
        position: absolute;
        top: 4px;
        right: 4px;
        padding: 0;
        border: none;
        background: transparent;
        color: inherit;
        cursor: pointer;
        opacity: 0.8;
      }`,
      `.pending-followup-toast--admin .pending-followup-toast__close,
      .pending-followup-toast--closable .pending-followup-toast__close {
        display: block;
      }`,
      `.pending-followup-fabs {
        display: flex;
        flex-direction: row;
        gap: 8px;
      }
      .pending-followup-fab {
        width: 40px;
        height: 40px;
        padding: 0;
        border: none;
        border-radius: 50%;
        background: #f59e0b;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      }
      .pending-followup-fab--admin {
        background: #dc2626;
      }`,
      `@media (max-width: 575.98px) {
        .pending-followup-toasts {
          left: 8px;
          right: 8px;
          bottom: 8px;
          gap: 6px;
        }
        .pending-followup-toast {
          max-width: none;
          padding: 8px 36px 8px 10px;
          animation: none;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        .pending-followup-toast__title {
          font-size: 13px;
          margin-bottom: 2px;
        }
        .pending-followup-toast__message {
          display: inline;
          font-size: 12px;
        }
        .pending-followup-toast__link {
          display: inline-block;
          margin-top: 0;
          margin-left: 6px;
          font-size: 12px;
        }
        .pending-followup-toast__close {
          display: block;
          width: 32px;
          height: 32px;
          line-height: 32px;
          font-size: 20px;
        }
      }`
    ],
    standalone: false
})
export class AppComponent implements OnInit {
  showReminder = false;
  showAdminReminder = false;
  reminderDismissed = false;
  adminReminderDismissed = true;
  pendingFollowUpCases: any[] = [];
  totalPendingFollowUpCases = 0;
  currentUserDisplayName = '';
  isAdmin = false;
  isAuthPage = true;
  private adminReminderInitialized = false;

  constructor(
    private router: Router,
    private statisticApiService: StatisticApiService,
    private tokenService: TokenService,
    private iconSetService: IconSetService,
  ) {
    // Register the CoreUI icon set so cIcon / nav iconComponent icons render.
    this.iconSetService.icons = { ...iconSubset };
  }

  ngOnInit() {
    this.currentUserDisplayName = this.getCurrentUserDisplayName();
    this.isAuthPage = this.isAuthUrl(this.router.url);

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
      this.isAuthPage = this.isAuthUrl(evt.urlAfterRedirects || evt.url);
      this.refreshPendingFollowUpReminder();
    });

    this.refreshPendingFollowUpReminder();

    interval(3 * 60 * 1000).subscribe(() => this.refreshPendingFollowUpReminder());
  }

  isAuthUrl(url: string) {
    const path = (url || '').split('?')[0].split('#')[0];
    return path === '/' || path === ''
      || path.startsWith('/login')
      || path.startsWith('/404')
      || path.startsWith('/500');
  }

  refreshPendingFollowUpReminder() {
    if (this.isAuthPage || !this.tokenService.getAccessToken()) {
      this.showReminder = false;
      this.showAdminReminder = false;
      this.pendingFollowUpCases = [];
      this.totalPendingFollowUpCases = 0;
      this.adminReminderInitialized = false;
      return;
    }

    this.currentUserDisplayName = this.getCurrentUserDisplayName();

    const roles = this.tokenService.getRoles() || '';
    this.isAdmin = roles.includes('Admin') || roles.includes('SuperAdmin');

    this.statisticApiService.getSummary().subscribe(response => {
      const statisticModel = response?.entity || {};
      const cases = statisticModel.pendingFollowUpCases || [];

      if (cases.length !== this.totalPendingFollowUpCases && this.adminReminderInitialized) {
        this.adminReminderDismissed = false;
      }
      this.adminReminderInitialized = true;

      this.totalPendingFollowUpCases = cases.length;
      this.showAdminReminder = this.isAdmin && this.totalPendingFollowUpCases > 0;

      if (!this.currentUserDisplayName) {
        this.pendingFollowUpCases = [];
        this.showReminder = false;
        return;
      }

      const currentUser = this.currentUserDisplayName.toLowerCase().trim();
      const myCases = cases.filter((item: any) => {
        const handler = (item?.handler || '').toString().toLowerCase().trim();
        return handler === currentUser || handler.includes(currentUser) || currentUser.includes(handler);
      });

      if (myCases.length !== this.pendingFollowUpCases.length) {
        this.reminderDismissed = false;
      }

      this.pendingFollowUpCases = myCases;
      this.showReminder = this.pendingFollowUpCases.length > 0;
    }, () => {
      this.pendingFollowUpCases = [];
      this.showReminder = false;
      this.totalPendingFollowUpCases = 0;
      this.showAdminReminder = false;
    });
  }

  getCurrentUserDisplayName() {
    const user = this.tokenService.getUser();

    if (!user) {
      return '';
    }

    try {
      const parsedUser = JSON.parse(user);
      return parsedUser.name || parsedUser.displayName || '';
    } catch (error) {
      return '';
    }
  }
}
